var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-schedule-event"},[_c('ActiveEventPanel',{attrs:{"event":_vm.event}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }